export const supportedCertificateFormats = ['crt', 'pem'];
